/**
 * BAR_CHART_CONFIG: a JSON object representing a schema used to drive bar charts for HighCharts.
 */
export const BAR_CHART_CONFIG: any = {
	chart: { type: 'bar' },
	legend: {
		enabled: true,
		floating: true,
		verticalAlign: 'bottom',
		itemMarginTop: 2,
		itemStyle: {
			fontFamily: '"FortBold", Arial, sans-serif',
			fontSize: '14px',
			lineHeight: '20px'
		},
		y: -2,
		align: 'left',
		navigation: { enabled: false }
	},
	plotOptions: {
		series: {
			pointPadding: 0.15
		}
	},
	xAxis: {
		lineWidth: 0,
		labels: {
			enabled: false
		},
		plotLines: [
			{
				color: '#a5a5a5',
				width: 1,
				value: -0.51
			}
		],
		tickLength: 0,
		title: {
			enabled: false
		}
	},
	yAxis: {
		visible: false,
		lineWidth: 0,
		labels: {
			enabled: false
		},
		title: {
			enabled: false
		}
	},
	title: {
		text: null
	}
};
